<template>
	<div>
		<h1>{{ title }}</h1>
		<div class="tag-sections">
			<section class="tag">
				<div class="description">
					<p class="font-weight-extra-bold">
						Mehrfachauswahl möglich, wenn unterschiedliche Arbeitsorte möglich sind.
					</p>
					<p>
						Wenn großteils Remote/Homeoffice vorgesehen ist, gib bitte Euren Hauptsitz für diesen Job ein.
					</p>
				</div>
				<PlaceOfWorkEdit
					v-model="placeOfWork"
					@input="emitChangeEvent"
				/>
			</section>
			<section class="tag">
				<h2>Bietet Ihr Homeoffice / Remote Work?</h2>
				<HomeOfficeEdit
					v-model="homeOffice"
					:first-label="false"
					simple
					@input="emitChangeEvent"
				/>
			</section>
		</div>
	</div>
</template>

<script>
import {mapState} from "vuex";
import PlaceOfWorkEdit from "@/vue/job-profile/place-of-work/Edit";
import HomeOfficeEdit from "@/vue/job-profile/home-office/Edit";
import {isDefined} from "@/helper/Value";

export default {
	components: {
		PlaceOfWorkEdit,
		HomeOfficeEdit
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		title: {
			type: String,
			required: true,
		},
	},

	data ()
	{
		return {
			placeOfWork: this.value?.placeOfWork,
			homeOffice: this.value?.homeOffice,
		};
	},

	computed: {
		...mapState('meta', [
			'meta',
		]),
		placeOfWorkValid ()
		{
			return isDefined(this.placeOfWork);
		},
		homeOfficeValid ()
		{
			return isDefined(this.homeOffice);
		},
		valid ()
		{
			return this.placeOfWorkValid
				&& this.homeOfficeValid;
		}
	},

	methods: {
		emitChangeEvent ()
		{
			this.$emit('input', {
				placeOfWork: this.placeOfWork,
				homeOffice: this.homeOffice,
				valid: this.valid,
			});
		}
	}
}
</script>
